import { FlexJustifyCenter, FlexCenter } from "../../../common/UI/Flex.js";
import { Label } from "../Styles.js";
import { buttonStyles, iconStrokeWidth } from "../../Table/Styles.js";
import styled, { css } from "styled-components";
const IndexColumnCellInner = styled.span`
  ${FlexJustifyCenter}
  text-align: center;
  width: 100%;
  height: 100%;
  overflow: hidden;
`;
const IndexRowCellInner = styled.span`
  ${FlexCenter}
  padding: 1px 5px;
  width: 100%;

  .pin-button,
  .sort-button {
    &.button-unselected button {
      ${() => buttonStyles({ icon: true })}
      display: none;
    }

    &.button-selected button {
      ${() => buttonStyles({ icon: true, active: true })}
      display: flex;
    }
  }

  .context-menu {
    display: none;
    position: relative;
  }

  .context-menu > button {
    ${() => buttonStyles({ icon: true })}
    ${() => iconStrokeWidth(1)}

    svg {
      transform: rotate(90deg);
    }
  }

  .context-menu li,
  .context-menu li span,
  .context-menu li div,
  .context-menu ::placeholder {
    font-size: ${({ theme }) => theme.baseFontSize} !important;
  }

  ${({ dragging }) => !dragging && css`
      &:hover {
        .pin-button,
        .sort-button {
          button {
            position: relative;
            display: flex !important;
            opacity: 1;

            svg {
              opacity: 1;
            }
          }
        }

        .context-menu {
          display: block;
        }

        div {
          div {
            max-width: unset;
            overflow: unset;
          }
        }
      }
    `}

  ${({ menuOpen }) => menuOpen && css`
      .context-menu {
        display: block;
      }
    `}
`;
const IndexRowCellRight = styled.div`
  flex-shrink: 0;
  display: flex;
  flex-grow: 1;
  height: 20px;
`;
const IndexButtonsContainer = styled.div`
  display: inline-flex;
  flex-grow: 1;
  align-items: center;
  justify-content: flex-start;
  padding-left: 4px;
  gap: 4px;

  ${({ hide }) => hide && ` max-width: 0;
    overflow: hidden;`}

  span:nth-of-type(2) {
    margin-left: auto;
  }
`;
const StyledLabel = styled(Label)`
  display: flex;
  align-items: center;
  font-weight: ${({ theme }) => theme.column.header.fontWeight};
  font-family: ${({ theme }) => theme.column.header.fontFamily};
  ${({ hidden }) => hidden && `visibility: hidden;`}
`;
styled.span`
  color: ${({ theme }) => theme.cell.removedColor} !important;
  font-style: italic;
`;
styled.span`
  position: absolute;
  right: 0;
  top: 6px;
`;
const ColumnHeaderIcon = styled.span`
  display: inline-flex;
  margin-right: 0.375em;
  color: ${({ theme }) => theme.filters.secondaryColor};
`;
const CheckboxWrapper = styled.div`
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  background: ${(props) => props.tintBackground ? props.theme.indexColumn.selected.backgroundColor : props.theme.indexColumn.backgroundColor};
  display: ${(props) => props.persist ? "flex" : "none"};
  justify-content: center;
  align-items: center;
`;
export {
  CheckboxWrapper,
  ColumnHeaderIcon,
  IndexButtonsContainer,
  IndexColumnCellInner,
  IndexRowCellInner,
  IndexRowCellRight,
  StyledLabel
};
